import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
let Tc = (props) => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="data-view-card-main">
          <p className="data-view-card-title">T&c</p>
        </div>
        <h1 className="tc-heading">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </h1>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <h1 className="tc-heading">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </h1>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <h1 className="tc-heading">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </h1>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <h1 className="tc-heading">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        </h1>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
        <p className="tc-description">
          Cras ut enim et mauris consequat aliquam. Praesent fringilla leo sed
          interdum tincidunt. Praesent commodo est vitae justo hendrerit
          venenatis. Pellentesque ut sollicitudin nisi. Aliquam mi erat, aliquam
          vitae accumsan quis, lobortis ut diam. Praesent ut purus orci. Aenean
          facilisis imperdiet odio, eu placerat nulla feugiat et. Pellentesque
          eget leo sit amet nulla varius faucibus.
        </p>
      </div>
    </SideMenu>
  );
};
export default Tc;
